<template>
  <skeleton :button="buttonLabel" @next="$emit('next')" :background="background">
    <vv-tips :title="title" :tips="stringTips" />
  </skeleton>
</template>

<script>
import { VvTips } from '@/components/common'
import Skeleton from './TransitionSkeleton'

export default {
  name: 'SpeechTransition',
  components: { Skeleton, VvTips },
  props: {
    background: String,
    title: String,
    tips: Array,
    buttonLabel: String
  },
  computed: {
    stringTips() {
      return this.tips.map(tips => tips.label)
    }
  }
}
</script>
